import { render, staticRenderFns } from "./PopScrollbar.vue?vue&type=template&id=0631fe39&scoped=true"
import script from "./PopScrollbar.vue?vue&type=script&lang=js"
export * from "./PopScrollbar.vue?vue&type=script&lang=js"
import style0 from "./PopScrollbar.vue?vue&type=style&index=0&id=0631fe39&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631fe39",
  null
  
)

export default component.exports